// LUMINA · pages/vajra/components/PublicEventCalendar.jsx
// Phase 39D: extracted from VajraPortal.jsx

import React, { useState } from 'react';
import { GD, GDB, GDH, TXT, TXT2 } from '../constants';

export default function PublicEventCalendar({ events, calMonth, setCalMonth, setSelectedEvent, lang }) {
  const year = calMonth.getFullYear();
  const month = calMonth.getMonth();
  const firstDow = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < firstDow; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  const mm = String(month + 1).padStart(2, "0");
  const byDay = {};
  events.forEach(ev => {
    // Collect all dates: start_date + session dates
    const dates = [];
    const ds = ev.start_date?.slice(0, 10);
    if (ds && ds.startsWith(`${year}-${mm}-`)) dates.push(ds);
    // Parse sessions (may be JSON string or array)
    let sessions = ev.sessions;
    if (typeof sessions === 'string') { try { sessions = JSON.parse(sessions); } catch(e) { sessions = []; } }
    if (Array.isArray(sessions)) {
      sessions.forEach(s => {
        if (s.date && s.date.startsWith(`${year}-${mm}-`)) dates.push(s.date);
      });
    }
    // Deduplicate dates and add to byDay
    [...new Set(dates)].forEach(ds2 => {
      const d = parseInt(ds2.slice(8, 10), 10);
      if (!byDay[d]) byDay[d] = [];
      byDay[d].push(ev);
    });
  });
  const todayStr = new Date().toLocaleDateString("en-CA");
  const isToday = d => { if (!d) return false; const dd = String(d).padStart(2, "0"); return `${year}-${mm}-${dd}` === todayStr; };
  const [expandedDay, setExpandedDay] = useState(null);
  const MN = ["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"];
  const DOW = ["日","一","二","三","四","五","六"];
  return (
    <div style={{background:"#fff",border:"1px solid rgba(212,175,55,0.28)",borderRadius:14,padding:24,overflowX:"auto",maxWidth:"100%"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:20}}>
        <button onClick={()=>setCalMonth(new Date(year,month-1,1))} style={{background:"none",border:"none",cursor:"pointer",fontSize:20,color:GD,padding:"4px 12px"}}>‹</button>
        <div style={{fontSize:15,color:TXT,fontWeight:600,letterSpacing:1}}>{year} · {MN[month]}</div>
        <button onClick={()=>setCalMonth(new Date(year,month+1,1))} style={{background:"none",border:"none",cursor:"pointer",fontSize:20,color:GD,padding:"4px 12px"}}>›</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:3,marginBottom:6}}>
        {DOW.map(d=><div key={d} style={{textAlign:"center",fontSize:11,color:TXT2,fontWeight:600,padding:"3px 0"}}>{d}</div>)}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:3}}>
        {cells.map((day,i)=>{
          const dayEvents = (byDay[day] || []).slice().sort((a, b) => {
            const ta = a.start_time || '99:99';
            const tb = b.start_time || '99:99';
            return ta.localeCompare(tb);
          });
          const isExpanded = expandedDay === day;
          const visibleEvents = isExpanded ? dayEvents : dayEvents.slice(0, 2);
          const hiddenCount = dayEvents.length - 2;
          return (
          <div key={i} style={{minHeight:56,minWidth:0,maxHeight:isExpanded?"none":96,overflow:"hidden",border:isToday(day)?`2px solid ${GDH}`:"1px solid rgba(212,175,55,0.15)",borderRadius:8,padding:"4px 2px",background:day?"#fff":"transparent"}}>
            {day&&<>
              <div style={{fontSize:11,color:isToday(day)?GD:TXT2,fontWeight:isToday(day)?700:400,textAlign:"center",marginBottom:3}}>{day}</div>
              {visibleEvents.map(ev=>(
                <div key={ev.id} onClick={()=>setSelectedEvent(ev)} title={ev.title_zh||ev.title} style={{
                  fontSize:10,color:"#fff",background:GDH,border:`1px solid ${GDB}`,
                  borderRadius:4,padding:"2px 4px",marginBottom:2,cursor:"pointer",
                  lineHeight:1.4,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",
                }}>{(lang==='en'&&ev.title_en?ev.title_en:ev.title_zh)||ev.title||(lang==='en'?'Event':'法会')}{ev.start_time&&<span style={{opacity:.7}}> {ev.start_time}</span>}</div>
              ))}
              {hiddenCount > 0 && (
                <div onClick={(e)=>{e.stopPropagation();setExpandedDay(isExpanded?null:day);}} style={{
                  fontSize:9,color:TXT2,textAlign:"center",cursor:"pointer",
                  padding:"2px 0",borderRadius:4,
                  background:"rgba(212,175,55,0.08)",border:`1px dashed rgba(212,175,55,0.25)`,
                }}>{isExpanded?"收起 ▲":`+${hiddenCount} more`}</div>
              )}
            </>}
          </div>
        )})}
      </div>
    </div>
  );
}
